import { render, staticRenderFns } from "./investmentPromotionContract.vue?vue&type=template&id=94dd2906&scoped=true&"
import script from "./investmentPromotionContract.vue?vue&type=script&lang=js&"
export * from "./investmentPromotionContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd2906",
  null
  
)

export default component.exports